/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free: NonNullable<unknown>, open: NonNullable<unknown> }} Directory_Launch_Stat_Free_OpenInputs */

const en_directory_launch_stat_free_open = /** @type {(inputs: Directory_Launch_Stat_Free_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free} free · ${i?.open} open-source`)
};

const zh_directory_launch_stat_free_open = /** @type {(inputs: Directory_Launch_Stat_Free_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free} 个免费 · ${i?.open} 个开源`)
};

/**
* | output |
* | --- |
* | "{free} free · {open} open-source" |
*
* @param {Directory_Launch_Stat_Free_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_stat_free_open = /** @type {((inputs: Directory_Launch_Stat_Free_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Stat_Free_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_stat_free_open(inputs)
	return zh_directory_launch_stat_free_open(inputs)
});
export { directory_launch_stat_free_open as "directory.launch.stat_free_open" }